module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "uk-navbar-container"
  }, [_c('div', {
    staticClass: "uk-navbar-left"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('b', [_vm._v("Vue-universal-modal")])])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("Docs")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/props"
    }
  }, [_vm._v("Props")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/examples"
    }
  }, [_vm._v("Examples")])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('page-content'), _vm._v(" "), _c('modal-wrapper')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/vuNemesis/vue-universal-modal"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "github"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-946714a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/App.vue
// module id = 222
// module chunks = 1